import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const TimelineMeta: ComponentMeta = {
  componentName: "Timeline",
  package: "@mijadesign/web",
  title: "时间轴",
  description: "展示时间进程",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "ClockCircleOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "mode",
      label: "模式",
      type: PropType.ENUM,
      options: [
        { label: "默认", value: "left" },
        { label: "交替", value: "alternate" },
      ],
      group: "样式",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Timeline",
  },
  snippet: {
    componentName: "Timeline",
    package: "@mijadesign/web",
    props: {},
  },
};

export const TimelineItemMeta: ComponentMeta = {
  componentName: "Timeline.Item",
  package: "@mijadesign/web",
  title: "时间轴项",
  description: "时间轴的单个节点",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "CircleOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "color",
      label: "颜色",
      type: PropType.ENUM,
      defaultValue: "blue",
      options: [
        { label: "蓝色", value: "blue" },
        { label: "红色", value: "red" },
        { label: "绿色", value: "green" },
        { label: "灰色", value: "gray" },
      ],
      group: "样式",
    },
  ],
  defaultProps: {
    color: "blue",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Timeline",
  },
  snippet: {
    componentName: "Timeline.Item",
    package: "@mijadesign/web",
    props: {},
  },
};
